module.exports = __webpack_public_path__ + "img/bangshangtoutiao.7095809e.gif";